import clsx from "clsx";
import type { PropsWithChildren } from "react";

const GridLayoutBody = ({
	children,
	className,
}: PropsWithChildren<{
	className?: string;
}>) => {
	return (
		<div className="flex w-full flex-1 flex-col">
			<div
				id="gridlayout-body"
				className={clsx(
					"overflow-y-auto overflow-x-hidden scroll-smooth px-3 tablet:px-5 py-3 tablet:py-4 pb-20 tablet:pb-16",
					className,
				)}
			>
				{children}
			</div>
		</div>
	);
};

export default GridLayoutBody;
